import * as R from 'ramda'
import { API_CONST } from '../middlewares/api'

import { handleActions, createAction } from 'redux-actions'

const initial = {
  state: 'login',
  loginId: null,
  userId: null,
  user: null,
  isLogged: false,
  settings: null,
  error: null,
  __data: {}
}

const generateActions = prefix => ([ `${prefix}/START`, `${prefix}/SUCCESS`, `${prefix}/FAILURE` ])

const authActions = generateActions('auth/auth')
const logoutActions = generateActions('auth/logout')
const claimLotActions = generateActions('auth/claimLot')
const setPersonData = generateActions('auth/setPersonData')
const setNameActions = generateActions('auth/setName')
const requestCodeActions = generateActions('auth/requestCode')
const confirmCodeActions = generateActions('auth/confirmCode')
const setRoleToUser = generateActions('auth/setRole')
const getUserActions = generateActions('auth/getUser')
const socialAuthActions = generateActions('auth/socialAuth')

//сохранение данных персоны на странице Обо мне
export const personData = createAction(API_CONST, (data = {}) => ({
  method: 'POST',
  params: { ...data },
  actions: setPersonData,
  url: `auth/person/profile`
}))

export const logIn = createAction(API_CONST, (login, userId) => ({
  method: 'post',
  url: 'auth/app',
  params: { login, userId },
  actions: authActions
}))

export const logInSocial = createAction(API_CONST, (provider, data = {}) => ({
  method: 'post',
  url: '../auth/oauthCheck',
  actions: socialAuthActions,
  params: { provider, data }
}))

export const logOut = createAction(API_CONST, login => ({
  method: 'post',
  url: 'auth/logout',
  actions: logoutActions
}))

export const requestCode = createAction(API_CONST, userLoginId => ({
  actions: requestCodeActions,
  url: `auth/app/auth/${userLoginId}`
}))

export const confirmCode = createAction(API_CONST, (userLoginId, codeValue, oldUser, CID) => ({
  method: 'post',
  params: { codeValue, oldUser, platform: 'site' , cid: CID},
  actions: confirmCodeActions,
  url: `auth/app/auth/${userLoginId}`
}))

//отправка роли пользователя 
export const setRole = createAction(API_CONST, (role) => ({
  method: 'post',
  params: { role: role },
  actions: setRoleToUser,
  url: 'auth/info/settings/role'
}))

export const setName = createAction(API_CONST, (userId, data, code) => ({
  method: 'post',
  actions: setNameActions,
  params: { ...data, lastCode: code, platform: 'site'},
  url: `auth/app/username/${userId}/`
}))

export const getUser = createAction(API_CONST, () => ({
  actions: getUserActions,
  url: `auth/user`
}))

export const setState = createAction('auth/SET_STATE', state => ({ state }))

// ------------ //

const getUserSettingsActions = generateActions('auth/getUserSettings')

export const claimAsLot = createAction(API_CONST, (data = {}) => ({
  method: 'POST',
  params: { ...data },
  actions: claimLotActions,
  url: `auth/offerLot`
}))

export const getUserSettings = createAction(
  API_CONST,
  () => ({
    url: 'auth/info/settings',
    actions: getUserSettingsActions
  })
)

export const setUserSettings = createAction(
  API_CONST,
  (data = {}) => ({
    params: data,
    method: 'POST',
    url: 'auth/info/settings',
    actions: getUserSettingsActions
  })
)

// ------------ //
const addEmailActions = generateActions('auth/addEmail')
export const addEmail = createAction(
  API_CONST,
  email => ({
  method: 'post',
  actions: addEmailActions,
  params: { email },//ctx.request.body
  url: 'auth/info/settings/addEmail'
}))

export const clearAuthData = createAction('auth/CLEAR_AUTH_DATA', () => null)
export const clearError = createAction('auth/CLEAR_AUTH_ERROR')

// ------------ //

const reduceUserError = (state, { payload }) => {
  // get error message if any
  const error = R.pathOr(null, [ 'payload', 'message', 'response', 'data', 'error' ], payload)

  // if error code !== 403, return default error state
  if (payload.status !== 403) return ({ ...state, error })

  // else, get response data
  const data = R.pathOr({}, [ 'message', 'response', 'data', 'data' ], payload)

  return ({ ...state, error, userId: data.userId, state: 'set', __data: R.pick([ 'email', 'phone', 'name', 'surname', 'birthday', 'birthmonth' ], data) })
}

// ------------ //

export default handleActions({
  [clearError]: state => ({ ...state, error: null }),
  [clearAuthData]: state => ({ ...state, state: 'login', loginId: null, userId: null }),
  [authActions[0]]: state => ({ ...state, error: null }),
  [authActions[1]]: (state, { payload }) => ({ ...state, loginId: payload.userLoginId, oldUser: payload.oldUser }),
  [authActions[2]]: (state, { payload }) => ({ ...state, error: payload.message.response.data.error }),
  //
  [requestCodeActions[0]]: state => ({ ...state, error: null }),
  [requestCodeActions[1]]: state => ({ ...state, state: 'confirm' }),
  [requestCodeActions[2]]: (state, { payload }) => ({ ...state, error: payload.message.response.data.error }),
  //
  [confirmCodeActions[0]]: state => ({ ...state, error: null }),
  [confirmCodeActions[1]]: state => ({ ...state, state: 'logged' }),
  [confirmCodeActions[2]]: reduceUserError,
  //
  [setNameActions[0]]: state => ({ ...state, error: null }),
  [setNameActions[1]]: state => ({ ...state, state: 'logged' }),
  [setNameActions[2]]: (state, { payload }) => ({ ...state, error: payload.message.response.data.error }),
  //
  [setState]: (state, { payload }) => ({ ...state, state: payload.state }),
  //
  [getUserActions[0]]: state => ({ ...state, error: null }),
  [getUserActions[1]]: (state, { payload }) => ({ ...state, isLogged: !!payload, user: payload || null }),
  [getUserActions[2]]: (state, { payload }) => ({ ...state, error: payload.message.response.data.error }),
  //
  [socialAuthActions[1]]: (state, { payload }) => ({ ...state, isLogged: !!payload, user: payload || null }),
  [socialAuthActions[2]]: reduceUserError,
  //
  [logoutActions[1]]: () => ({ ...initial }),
  //
  [getUserSettingsActions[0]]: state => ({ ...state, settings: null, error: null }),
  [getUserSettingsActions[2]]: (state, { payload }) => ({ ...state, settings: null, error: payload.message.response.data.error }),
  [getUserSettingsActions[1]]: (state, { payload }) => ({ ...state, settings: payload }),
  //
  [addEmailActions[1]]: (state, {payload}) => ({...state, payload: payload})
}, initial)



// WEBPACK FOOTER //
// ./src/store/reducers/auth.js